import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import setupInterceptors from "./services/interceptor";
import { createMetaManager } from "vue-meta";
import en from "./common/en";
import tn from "./common/tn";
import fr from "./common/fr";
import "@/styles/globals.css";

import { createI18n } from "vue-i18n";
import "./registerServiceWorker";

const i18n = createI18n({
  locale: navigator.language,
  fallbackLocale: "en",
  messages: { tn, en, fr },
  legacy: false,
});

setupInterceptors(store);

createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(createMetaManager())
  .mount("#app");
